module.exports = __webpack_public_path__ + "img/italic.78f0e4c7.svg";